const Batch = {
  queryList: [
    {
      name: 'name',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'status',
      label: '是否生效',
      notNull: true,
      component: 'select',
      value: '1',
      componentAttr: {
        options: [{
          value: '1',
          label: '是',
          checked: true
        }, {
          value: '0',
          label: '否'
        }
        ]
      }
    }
  ],
  urlMap: {
    select: '/school/schoolAcademy/list',
    update: '/school/schoolAcademy/saveOrUpdate',
    delete: '/school/schoolAcademy/delete/{id}'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/academyConfigEdit'
      }
    }
  ],
  titles: [
    {
      name: 'name',
      label: '院系名称'
    },
    {
      name: 'status',
      label: '是否生效'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '编辑',
          name: 'edit',
          width: 800,
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'systemManage/academyConfigEdit?{id}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认删除？'
          }
        }
      ]
    }
  ]
}
export default Batch



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/academyConfig.js